var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EA7270"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.764 22.7453C29.6385 23.2792 29.334 23.7541 28.9011 24.0908C28.4682 24.4275 27.933 24.6058 27.3847 24.596L27.1854 24.5835L25.2595 24.3889C24.675 24.3298 24.1207 24.1001 23.6656 23.7285C23.2106 23.3569 22.8748 22.8597 22.7001 22.2988L22.6427 22.0813L22.2573 20.4136C22.1852 20.1114 21.3845 19.8446 19.7523 19.8444C18.2835 19.8445 17.4703 20.065 17.2952 20.3034L17.2694 20.3481L17.248 20.4092L16.6696 22.9158C16.5921 23.2528 16.4192 23.5604 16.1715 23.8017C15.9238 24.043 15.6119 24.2079 15.2729 24.2766L15.0988 24.3021L12.3309 24.5844C11.7884 24.6396 11.2432 24.5085 10.7851 24.2126C10.3271 23.9167 9.98349 23.4735 9.81091 22.9563L9.75317 22.7539L9.54421 21.8822C9.35722 21.0999 9.39884 20.2803 9.6641 19.5209C9.92936 18.7615 10.4071 18.0942 11.0405 17.5985C13.0121 16.0556 15.9189 15.2978 19.7516 15.2977C23.5934 15.2988 26.5042 16.0579 28.4772 17.6085C29.0735 18.0774 29.5318 18.699 29.8033 19.4073C30.0747 20.1157 30.1493 20.8843 30.019 21.6316L29.9697 21.8706L29.764 22.7453V22.7453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end_call.0b87f7c8a3ec3a1e6c6bd16671c02d61.svg";
export { ForwardRef as ReactComponent };